import { Tooltip, TooltipProps, styled, tooltipClasses } from "@mui/material";

export const bioHeader = [
  "BIO1-A",
  "BIO1-B",
  "BIO1-C",
  "BIO1-D",
  "BIO2-A",
  "BIO2-B",
  "BIO2-C",
  "BIO2-D",
  "BIO3-A",
  "BIO3-B",
  "BIO3-C",
  "BIO3-D",
  "BIO4-A",
  "BIO4-B",
  "BIO4-C",
  "BIO4-D",
];
export const bioindexHeader = ["BIO Index", "BIO Index PSD"];

export const bioEquationHeader = ["LED1", "LED2", "LED3", "LED4"];
export const bioEquationFactorsHeader = [
  "ID",
  "Type",
  "R",
  "B",
  "LO",
  "A",
  "L",
  "N",
];
export const GasesHeader = [
  "ID",
  "Characteristic",
  "Option Type",
  "Active option",
  "Current active",
  "A",
  "B",
  "C",
  "D",
];
export const PieraCSVHeader = [
  "ID",
  "Characteristic",
  "Option Type",
  "Active option",
  "Current active",
  "A",
  "B",
  "C",
  "D",
];
export const bioChamberCSVHeader = [
  "ID",
  "Characteristic",
  "Option Type",
  "Active option",
  "Current active",
  "A",
  "B",
  "C",
  "D",
];
export const APSWeightHeader = ["ID", "A"];
export const ISOLevelHeader = [
  "ID",
  "ISO Level",
  "Index",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
];

export const tpmHeader = [
  "TPM1-A",
  "TPM1-B",
  "TPM1-C",
  "TPM1-D",
  "TPM2-A",
  "TPM2-B",
  "TPM2-C",
  "TPM2-D",
  "TPM3-A",
  "TPM3-B",
  "TPM3-C",
  "TPM3-D",
  "TPM4-A",
  "TPM4-B",
  "TPM4-C",
  "TPM4-D",
];
export const pmHeader = [
  "PM1-A",
  "PM1-B",
  "PM1-C",
  "PM1-D",
  "PMDOT5-A",
  "PMDOT5-B",
  "PMDOT5-C",
  "PMDOT5-D",
  "PM4-A",
  "PM4-B",
  "PM4-C",
  "PM4-D",
  "PM10-A",
  "PM10-B",
  "PM10-C",
  "PM10-D",
];
export const sensorHeader = [
  "O2-SENS",
  "ETO-SENS",
  "CO-SENS",
  "Alcohol-SENS",
  "O3-SENS",
  "NO2-SENS",
  "SO2-SENS",
  "H2O2-SENS",
  "CL2-SENS",
  "NH3-SENS",
];
export const zeroHeader = [
  "O2-ZERO",
  "ETO-ZERO",
  "CO-ZERO",
  "Alcohol-ZERO",
  "O3-ZERO",
  "NO2-ZERO",
  "SO2-ZERO",
  "H2O2-ZERO",
  "CL2-ZERO",
  "NH3-ZERO",
];
export const allHeader = [
  ...bioHeader,
  ...tpmHeader,
  ...pmHeader,
  ...sensorHeader,
  ...zeroHeader,
];

export const bioHeaderDownload = [
  "ID,BIO1-A,BIO1-B,BIO1-C,BIO1-D,BIO2-A,BIO2-B,BIO2-C,BIO2-D,BIO3-A,BIO3-B,BIO3-C,BIO3-D,BIO4-A,BIO4-B,BIO4-C,BIO4-D",
];
export const tpmHeaderDownload = [
  "ID,TPM1-A,TPM1-B,TPM1-C,TPM1-D,TPM2-A,TPM2-B,TPM2-C,TPM2-D,TPM3-A,TPM3-B,TPM3-C,TPM3-D,TPM4-A,TPM4-B,TPM4-C,TPM4-D",
];
export const pmHeaderDownload = [
  "ID,PM1-A,PM1-B,PM1-C,PM1-D,PMDOT5-A,PMDOT5-B,PMDOT5-C,PMDOT5-D,PM4-A,PM4-B,PM4-C,PM4-D,PM10-A,PM10-B,PM10-C,PM10-D",
];
export const sensorHeaderDownload = [
  "ID,O2-SENS,ETO-SENS,CO-SENS,Alcohol-SENS,O3-SENS,NO2-SENS,SO2-SENS,H2O2-SENS,CL2-SENS,NH3-SENS",
];
export const zeroHeaderDownload = [
  "ID,O2-ZERO,ETO-ZERO,CO-ZERO,Alcohol-ZERO,O3-ZERO,NO2-ZERO,SO2-ZERO,H2O2-ZERO,CL2-ZERO,NH3-ZERO",
];
export const allHeaderDownload = [
  "ID,BIO1-A,BIO1-B,BIO1-C,BIO1-D,BIO2-A,BIO2-B,BIO2-C,BIO2-D,BIO3-A,BIO3-B,BIO3-C,BIO3-D,BIO4-A,BIO4-B,BIO4-C,BIO4-D,TPM1-A,TPM1-B,TPM1-C,TPM1-D,TPM2-A,TPM2-B,TPM2-C,TPM2-D,TPM3-A,TPM3-B,TPM3-C,TPM3-D,TPM4-A,TPM4-B,TPM4-C,TPM4-D,PM1-A,PM1-B,PM1-C,PM1-D,PM2-A,PM2-B,PM2-C,PM2-D,PM3-A,PM3-B,PM3-C,PM3-D,PM4-A,PM4-B,PM4-C,PM4-D,O2-SENS,ETO-SENS,CO-SENS,Alcohol-SENS,O3-SENS,NO2-SENS,SO2-SENS,H2O2-SENS,CL2-SENS,NH3-SENS,O2-ZERO,ETO-ZERO,CO-ZERO,Alcohol-ZERO,O3-ZERO,NO2-ZERO,SO2-ZERO,H2O2-ZERO,CL2-ZERO,NH3-ZERO",
];
export const bioIndexHeaderDownload = ["ID,BIO Index,BIO Index PSD"];
export const bioEquationDownload = ["ID,LED1,LED2,LED3,LED4"];

export const tpmPageHeander: any = [
  { name: "TPM CH1", value: "v_tpm_ch1" },
  { name: "TPM CH2", value: "v_tpm_ch2" },
  { name: "TPM CH3", value: "v_tpm_ch3" },
  { name: "TPM CH4", value: "v_tpm_ch4" },
];
export const awsVariablePageHeander: any = [
  { name: "LED1", value: "v_aws_led1" },
  { name: "LED2", value: "v_aws_led2" },
  { name: "LED3", value: "v_aws_led3" },
  { name: "LED4", value: "v_aws_led4" },
  // { name: "LED5", key: "v_aws_led5" },
];
export const equationPageHeander: any = [
  { name: "r", value: "r" },
  { name: "b", value: "b" },
  { name: "lo", value: "lo" },
  { name: "a", value: "a" },
  { name: "l", value: "l" },
  { name: "n", value: "n" },
];

export const bioPageHeander: any = [
  { name: "BIO CH1", value: "v_bio_ch1" },
  { name: "BIO CH2", value: "v_bio_ch2" },
  { name: "BIO CH3", value: "v_bio_ch3" },
  { name: "BIO CH4", value: "v_bio_ch4" },
];
export const bioIndexPageHeander: any = [
  { name: "BIO Index", value: "v_bioi" },
];
export const bioIndexPageHeanderPSD: any = [
  { name: "BIO Index", value: "v_bioipsd" },
];

export const pmPageHeander: any = [
  { name: "PM0.5", value: "v_pm0dot5" },
  { name: "PM1", value: "v_pm1" },
  { name: "PM2.5", value: "v_pm2dot5" },
  { name: "PM4", value: "v_pm4" },
  { name: "PM10", value: "v_pm10" },
];

export const pmPageHeanderPSD: any = [
  { name: "PM0.5PSD", value: "v_pm0dot5psd" },
  { name: "PM1PSD", value: "v_pm1psd" },
  { name: "PM2.5PSD", value: "v_pm2dot5psd" },
  { name: "PM4PSD", value: "v_pm4psd" },
  { name: "PM10PSD", value: "v_pm10psd" },
];

export const pmNewPageHeander: any = [
  { name: "PM10", value: "v_pm10" },
  { name: "PM2.5", value: "v_pm2dot5" },
  { name: "PM1", value: "v_pm1" },
  { name: "PM5", value: "v_pm5" },
  { name: "PM0.5", value: "v_pm0dot5" },
  { name: "PM0.1", value: "v_pm0dot1" },
  { name: "PM0.3", value: "v_pm0dot3" },
];
export const APSWeightsHeander: any = [
  { name: "PC.1", value: "aps_pc0dot1" },
  { name: "PC.3", value: "aps_pc0dot3" },
  { name: "PC.5", value: "aps_pc0dot5" },
  { name: "PC1", value: "aps_pc1" },
  { name: "PC2.5", value: "aps_pc2dot5" },
  { name: "PC5", value: "aps_pc5" },
  { name: "PC10", value: "aps_pc10" },
];
export const apsPageHeander: any = [{ name: "APS(#)", value: "m_aps" }];
export const ISOLevelsHeander1: any = [
  { name: "ISO-1", value: "ISO_1" },
  { name: "ISO-2", value: "ISO_2" },
  { name: "ISO-3", value: "ISO_3" },
  { name: "ISO-4", value: "ISO_4" },
  { name: "ISO-5", value: "ISO_5" },
  { name: "ISO-6", value: "ISO_6" },
  { name: "ISO-7", value: "ISO_7" },
  { name: "ISO-8", value: "ISO_8" },
  { name: "ISO-9", value: "ISO_9" },
];
export const ISOLevelsHeander2: any = [
  { name: "A", value: "A" },
  { name: "B", value: "B" },
  { name: "C", value: "C" },
  { name: "D", value: "D" },
  { name: "E", value: "E" },
  { name: "F", value: "F" },
  { name: "G", value: "G" },
];

export const PieraHeader: any = [
  { type: "raw", name: "0.1", value: ["v_1_pm0dot1", "v_1_pc0dot1"] },
  { type: "custom", name: "0.1", value: ["v_2_pm0dot1", "v_2_pc0dot1"] },
  { type: "raw", name: "0.3", value: ["v_1_pm0dot3", "v_1_pc0dot3"] },
  { type: "custom", name: "0.3", value: ["v_2_pm0dot3", "v_2_pc0dot3"] },
  { type: "raw", name: "0.5", value: ["v_1_pm0dot5", "v_1_pc0dot5"] },
  { type: "custom", name: "0.5", value: ["v_2_pm0dot5", "v_2_pc0dot5"] },
  { type: "raw", name: "1", value: ["v_1_pm1", "v_1_pc1"] },
  { type: "custom", name: "1", value: ["v_2_pm1", "v_2_pc1"] },
  { type: "raw", name: "2.5", value: ["v_1_pm2dot5", "v_1_pc2dot5"] },
  { type: "custom", name: "2.5", value: ["v_2_pm2dot5", "v_2_pc2dot5"] },
  { type: "raw", name: "5", value: ["v_1_pm5", "v_1_pc5"] },
  { type: "custom", name: "5", value: ["v_2_pm5", "v_2_pc5"] },
  { type: "raw", name: "10", value: ["v_1_pm10", "v_1_pc10"] },
  { type: "custom", name: "10", value: ["v_2_pm10", "v_2_pc10"] },
];

// {type: "custompc",  name: "LED-280", value: ["v_4_bio_280_pc"]},
// {type: "custompc",  name: "LED-340", value: ["v_4_bio_340_pc"]},
// {type: "custompc",  name: "LED-370", value: ["v_4_bio_370_pc"]},
// {type: "custompc",  name: "LED-405", value: ["v_4_bio_405_pc"]},

export const bioChamberHeanderPC: any = [
  { type: "raw", name: "LED-280", value: ["v_1_bio_280_pc"] },
  { type: "manufactured", name: "LED-280", value: ["v_2_bio_280_pc"] },
  { type: "custom", name: "LED-280", value: ["v_3_bio_280_pc"] },
  { type: "raw", name: "LED-340", value: ["v_1_bio_340_pc"] },
  { type: "manufactured", name: "LED-340", value: ["v_2_bio_340_pc"] },
  { type: "custom", name: "LED-340", value: ["v_3_bio_340_pc"] },
  { type: "raw", name: "LED-370", value: ["v_1_bio_370_pc"] },
  { type: "manufactured", name: "LED-370", value: ["v_2_bio_370_pc"] },
  { type: "custom", name: "LED-370", value: ["v_3_bio_370_pc"] },
  { type: "raw", name: "LED-405", value: ["v_1_bio_405_pc"] },
  { type: "manufactured", name: "LED-405", value: ["v_2_bio_405_pc"] },
  { type: "custom", name: "LED-405", value: ["v_3_bio_405_pc"] },
];
export const bioChamberHeanderPM: any = [
  { type: "raw", name: "LED-280", value: ["v_1_bio_280_pm"] },
  { type: "manufactured", name: "LED-280", value: ["v_2_bio_280_pm"] },
  { type: "custom", name: "LED-280", value: ["v_3_bio_280_pm"] },
  { type: "custompm", name: "LED-280", value: ["v_4_bio_280_pm"] },
  { type: "raw", name: "LED-340", value: ["v_1_bio_340_pm"] },
  { type: "manufactured", name: "LED-340", value: ["v_2_bio_340_pm"] },
  { type: "custom", name: "LED-340", value: ["v_3_bio_340_pm"] },
  { type: "custompm", name: "LED-340", value: ["v_4_bio_340_pm"] },
  { type: "raw", name: "LED-370", value: ["v_1_bio_370_pm"] },
  { type: "manufactured", name: "LED-370", value: ["v_2_bio_370_pm"] },
  { type: "custom", name: "LED-370", value: ["v_3_bio_370_pm"] },
  { type: "custompm", name: "LED-370", value: ["v_4_bio_370_pm"] },
  { type: "raw", name: "LED-405", value: ["v_1_bio_405_pm"] },
  { type: "manufactured", name: "LED-405", value: ["v_2_bio_405_pm"] },
  { type: "custom", name: "LED-405", value: ["v_3_bio_405_pm"] },
  { type: "custompm", name: "LED-405", value: ["v_4_bio_405_pm"] },
];

export const bioSummaryPC: any = [
  { type: "raw", name: "BIOPC", value: "v_bio_1_pc" },
  { type: "manufactured", name: "BIOPC", value: "v_bio_2_pc" },
  { type: "custom", name: "BIOPC", value: "v_bio_3_pc" },
];
export const bioSummaryPM: any = [
  { type: "raw", name: "BIOPM", value: "v_bio_1_pm" },
  { type: "manufactured", name: "BIOPM", value: "v_bio_2_pm" },
  { type: "custom", name: "BIOPM", value: "v_bio_3_pm" },
  { type: "custompc", name: "BIOPM", value: "v_bio_4_pm" },
];

export const gasesCalibrationHeander1: any = [
  // { type: "raw", name: "O2", unit:"ppb", value: "v_1_o2" }, { type: "manufactured", name: "O2", unit:"ppb", value: "v_2_o2" }, { type: "custom", name: "O2", unit:"ppb", value: "v_3_o2" },
  // { type: "raw", name: "ALC", unit:"ppb" , value: "v_1_alc" }, { type: "manufactured", name: "ALC", unit:"ppb", value: "v_2_alc" }, { type: "custom", name: "ALC", unit:"ppb", value: "v_3_alc" },
  { type: "raw", name: "ETO", unit: "ppm", value: "v_1_eto" },
  { type: "manufactured", name: "ETO", unit: "ppm", value: "v_2_eto" },
  { type: "custom", name: "ETO", unit: "ppm", value: "v_3_eto" },
  { type: "raw", name: "CO2", unit: "ppb", value: "v_1_co2" },
  { type: "manufactured", name: "CO2", unit: "ppb", value: "v_2_co2" },
  { type: "custom", name: "CO2", unit: "ppb", value: "v_3_co2" },
  { type: "raw", name: "CO", unit: "ppb", value: "v_1_co" },
  { type: "manufactured", name: "CO", unit: "ppb", value: "v_2_co" },
  { type: "custom", name: "CO", unit: "ppb", value: "v_3_co" },
  { type: "raw", name: "O3", unit: "ppb", value: "v_1_o3" },
  { type: "manufactured", name: "O3", unit: "ppb", value: "v_2_o3" },
  { type: "custom", name: "O3", unit: "ppb", value: "v_3_o3" },
  { type: "raw", name: "NO2", unit: "ppb", value: "v_1_no2" },
  { type: "manufactured", name: "NO2", unit: "ppb", value: "v_2_no2" },
  { type: "custom", name: "NO2", unit: "ppb", value: "v_3_no2" },
  { type: "raw", name: "SO2", unit: "ppb", value: "v_1_so2" },
  { type: "manufactured", name: "SO2", unit: "ppb", value: "v_2_so2" },
  { type: "custom", name: "SO2", unit: "ppb", value: "v_3_so2" },
  { type: "raw", name: "HCHO", unit: "ppb", value: "v_1_hcho" },
  { type: "manufactured", name: "HCHO", unit: "ppb", value: "v_2_hcho" },
  { type: "custom", name: "HCHO", unit: "ppb", value: "v_3_hcho" },
  { type: "raw", name: "H2O2", unit: "ppb", value: "v_1_h2o2" },
  { type: "manufactured", name: "H2O2", unit: "ppb", value: "v_2_h2o2" },
  { type: "custom", name: "H2O2", unit: "ppb", value: "v_3_h2o2" },
  { type: "raw", name: "CL2", unit: "ppm", value: "v_1_cl2" },
  { type: "manufactured", name: "CL2", unit: "ppm", value: "v_2_cl2" },
  { type: "custom", name: "CL2", unit: "ppm", value: "v_3_cl2" },
  { type: "raw", name: "NH3", unit: "ppb", value: "v_1_nh3" },
  { type: "manufactured", name: "NH3", unit: "ppb", value: "v_2_nh3" },
  { type: "custom", name: "NH3", unit: "ppb", value: "v_3_nh3" },
  { type: "raw", name: "4CH3OH", unit: "ppm", value: "v_1_4ch3oh" },
  { type: "manufactured", name: "4CH3OH", unit: "ppm", value: "v_2_4ch3oh" },
  { type: "custom", name: "4CH3OH", unit: "ppm", value: "v_3_4ch3oh" },
  { type: "raw", name: "CH4", unit: "ppm", value: "v_1_ch4" },
  { type: "manufactured", name: "CH4", unit: "ppm", value: "v_2_ch4" },
  { type: "custom", name: "CH4", unit: "ppm", value: "v_3_ch4" },
];

export const NeedTOSwitch: any = ["CO", "H2O2", "O3", "SO2", "NO2", "NH3"];

export const pmNewPageHeanderPSD: any = [
  { name: "PM10", value: "v_pm10psd" },
  { name: "PM2.5", value: "v_pm2dot5psd" },
  { name: "PM1", value: "v_pm1psd" },
  { name: "PM5", value: "v_pm5psd" },
  { name: "PM0.5", value: "v_pm0dot5psd" },
  { name: "PM0.1", value: "v_pm0dot1psd" },
  { name: "PM0.3", value: "v_pm0dot3psd" },
];

export const arrAbc: any = [
  { name: "A", value: "A" },
  { name: "B", value: "B" },
  { name: "C", value: "C" },
  { name: "D", value: "D" },
];

export const substancesList = [
  {
    name: "Oxygen",
    shortname: "O2",
    key: "v_o2",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Ethylene Oxide",
    shortname: "ETO",
    key: "v_eto",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Carbon Monoxide",
    shortname: "CO",
    key: "v_co",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Alcohol",
    shortname: "Alcohol",
    key: "v_alcohol",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Ozone",
    shortname: "O3",
    key: "v_o3",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Nitrogen Dioxide",
    shortname: "NO2",
    key: "v_no2",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Sulfur Dioxide",
    shortname: "SO2",
    key: "v_so2",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Hydrogen Peroxide",
    shortname: "H2O2",
    key: "v_h2o2",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Chlorine",
    shortname: "CL2",
    key: "v_cl2",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
  {
    name: "Ammonia",
    shortname: "NH3",
    key: "v_nh3",
    sensitivity: "nA/ppm",
    ec_zero: "V",
  },
];

export const biotpm_sensor = "mcp3424_6E";
export const pm_sensor = "sen54_69";
export const sencitivity_sensor = "mcp3424_6A";
export const ecZero_sensor = "mcp3424_6A";

export const substanceData = [
  "temperature",
  "humidity",
  "alcohol",
  "pm2dot5",
  "isopm10psd",
  "o3",
  "no2",
  "co",
  "so2",
  "h2s",
  "c_ch4",
  "nh3",
  "h2o2",
  "hcho",
  "cl2",
  "co2",
  "pm1",
  "pm4",
  "pm10",
  "voc",
  "nox",
  "v_bio",
  "v_total",
  "v_bio2",
  "v_total2",
  "bio",
  "biop",
  "tpm",
  "thi",
  "thir",
  "v_bio_270_drk",
  "v_total_405_drk",
  "v_bio_405_drk",
  "v_total_270_drk",
  "o2",
  "n2",
  "eto",
  "v_tpm_ch1",
  "v_bio_ch1",
  "v_tpm_ch2",
  "v_bio_ch2",
  "v_tpm_ch3",
  "v_bio_ch3",
  "v_tpm_ch4",
  "v_bio_ch4",
  "bio_ch1",
  "bio_ch2",
  "bio_ch3",
  "bio_ch4",
  "tpm_ch1",
  "tpm_ch2",
  "tpm_ch3",
  "tpm_ch4",
  "pm4psd",
  "pm0dot5",
  "pm0dot5psd",
  "tps",
  "pm10psd",
  "pm1psd",
  "pm2dot5psd",
  "pc0dot1",
  "pc2dot5",
  "pc0dot3",
  "pc0dot5",
  "pc10",
  "pc5",
  "pm5",
  "pm0dot1",
  "pc1",
  "pm0dot3",
];

export const sensorId = [
  "scd41_62",
  "mcp3424_6A",
  "mcp3424_6E",
  "sfa30_5D",
  "sen54_69",
  "scd42_62",
  "ips7100_4B",
];

export const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "559",
    color: "rgba(255,255,255)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

export const substanceGroups = [
  {
    value: "chems",
    label: "Chemicals",
  },
  {
    value: "particulate",
    label: "Particulates",
  },
  {
    value: "gas",
    label: "Gases",
  },
  {
    value: "thi",
    label: "Thi",
  },
];
export const substanceUnits = [
  {
    value: "ppm",
    label: "ppm",
  },
  {
    value: "%",
    label: "%",
  },
  {
    value: "#M/m3",
    label: "#M/m3",
  },
];

export const substanceConfiguration = [
  {
    substanceKey: "o3",
    displayName: "o3",
    order: 8,
    unit: "ppm",
    group: "gas",
  },
  {
    substanceKey: "co",
    displayName: "co",
    order: 7,
    unit: "ppm",
    group: "gas",
  },
  {
    substanceKey: "co2",
    displayName: "co2",
    order: 6,
    unit: "ppm",
    group: "gas",
  },
  {
    substanceKey: "no2",
    displayName: "no2",
    order: 19,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "so2",
    displayName: "so2",
    order: 20,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "nh3",
    displayName: "nh3",
    order: 16,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "h2o2",
    displayName: "h2o2",
    order: 13,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "cl2",
    displayName: "cl2",
    order: 15,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "alcohol",
    displayName: "alcohol",
    order: 14,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "hcho",
    displayName: "hcho",
    order: 18,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "pm2dot5",
    displayName: "pm2.5",
    order: 2,
    unit: "ug/m3",
    group: "particulate",
  },
  {
    substanceKey: "pm10",
    displayName: "TPM",
    order: 1,
    unit: "ug/m3",
    group: "particulate",
  },
  {
    substanceKey: "chems",
    displayName: "chems",
    order: 0,
    unit: "ppm",
    group: "chems",
  },
  {
    substanceKey: "gas",
    displayName: "gas",
    order: 0,
    unit: "ppm",
    group: "gas",
  },
  {
    substanceKey: "voc",
    displayName: "voc",
    order: 12,
    unit: "ppm",
    group: "voc",
  },
  {
    substanceKey: "pm1",
    displayName: "pm",
    order: 0,
    unit: "ug/m3",
    group: "pm1",
  },
  {
    substanceKey: "tpm",
    displayName: "pm",
    order: 0,
    unit: "ug/m3",
    group: "tpm",
  },
  {
    substanceKey: "biop",
    displayName: "bio%",
    order: 4,
    unit: "%",
    group: "particulate",
  },
  {
    substanceKey: "temperature",
    displayName: "temp",
    order: 0,
    unit: "f",
    group: "wthr",
  },
  {
    substanceKey: "humidity",
    displayName: "humidity",
    order: 0,
    unit: "%",
    group: "wthr",
  },
  {
    substanceKey: "c_ch4",
    displayName: "ch4",
    order: 9,
    unit: "ppm",
    group: "gas",
  },
  {
    substanceKey: "pm10psd",
    displayName: "TPM",
    order: 0,
    unit: "#M/m3",
    group: "pm10psd",
  },
  {
    substanceKey: "pm2dot5psd",
    displayName: "pm2.5",
    order: 2,
    unit: "#M/m3",
    group: "pm2dot5psd",
  },
  {
    substanceKey: "isopm10psd",
    displayName: "ISO",
    order: 3,
    unit: "#M/m3",
    group: "particulate",
  },
  {
    substanceKey: "thi",
    displayName: "THI",
    order: 0,
    unit: "",
    group: "thi",
  },
];
export const TRACKING_ID = "G-SWJ7DTCMZC";

export const TimeIntervalsKeys = {
  FIVE_M: "5m",
  MINUTE: "1m",
  HOUR: "1h",
  DAY: "1d",
  // WEEK:'1w',
  WEEK: "7d",
  MONTH: "30d",
};

export const routeWhichIsNotInMenu = [
  "/notifications",
  "/notifications/",
  "/profile",
  "/profile/",
  "/schedule-reports",
  "/schedule-reports/",
  "/element-detection/*",
  "/ieq-gpt",
  "/verify"
];

export const dynamicRoutesWhichIsNotMenu = [
  "/summary",
  "/summary/",
  "/eventMapImageupload",
  "/eventMapImageupload/",
];
export const dynamicEmailTemplateVariable: any = [
  {
    label: "Select Field",
    value: "",
  },
  {
    label: "User Name",
    value: "username",
  },
];
export const dynamicMessageTextVariable: any = [
  {
    label: "{username}",
    value: "{username}",
  },
  {
    label: "{####}",
    value: "{####}",
  },
];

export const substanceKeyscheck: any = ["thir"];
export const checkWithSubstanceZeroDecimal = ["pcc10", "pcc2dot5"];
export const checkWithSubstanceOneDecimal = ["pm10", "pm2dot5"];
export const checkWithSubstanceBioPercentage = ["pm_biop", "pc_biop"];
export const SubstancesIcons: any = {
  "temperature": "Temperature_light",
  "pm10": "Temperature_light",
  "ch4": "Temperature_light",
  "humidity": "humidity_light",
  "pm2dot5": "humidity_light",
  "so2": "humidity_light",
  "4ch3oh": "humidity_light",
  "pcc10": "humidity_light",
  "pcc2dot5": "humidity_light",
  "eto": "humidity_light",
  "hcho": "Cloud_light",
  "thi": "Cloud_light",
  "o3": "Cloud_light",
  "nh3": "Cloud_light",
  "pm_biop": "Cloud_light",
  "pm2dot5psd": "Cloud_light",
  "pmdot5": "Cloud_light",
  "isopm10psd": "Sunlight_light",
  "co2": "Sunlight_light",
  "co": "Sunlight_light",
  "h2o2": "Sunlight_light",
  "pc_bioi": "Sunlight_light",
  "pm_bioi": "Sunlight_light",
  "pc_bio": "Sunlight_light",
  "thir": "Winter_light",
  "cl2": "Winter_light",
  "no2": "Winter_light",
  "pcdot5": "Winter_light",
  "pm_bio": "Winter_light",
  "pc_biop": "Winter_light",
  "pm1": "Winter_light",
  "pm10psd": "Winter_light",
}

export const defaultCategoryDisabled:any = ['particulates','bio',"chemicals","gases"]
export const substanceReplace:any = {
  ambient_light: "ambient_light",
  barometric_pressure: "barometric_pressure",
  carbon_dioxide: "co2",
  carbon_monoxide: "co",
  formaldehyde: "formaldehyde",
  heat_index:"heat_index",
  humidity: "humidity",
  motion: "motion",
  noise_level: "noise_level",
  pm_1_0_0: "pm10",
  pm_2_5: "pm2dot5",
  pm_4_0: "pm4",
  tamper: "tamper",
  temperature: "temperature",
  time: "time",
  tvoc_index: "vox",
  usa_air_quality_index: "usa_air_quality_index",
  vape_index: "vape_index"
}
